<template>
  <div>
    {{ name }}
  </div>
</template>

<script>
export default {
  name: 'zlj_package',
  props: {
    name: {
      type: String,
      default: 'test'
    }
  },
  data() { 
    return {}
  },
   mounted() {}, 
   methods: {}
 }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/lib/zlj-package.vue